export function postsListingSearch() {
  const input = document.querySelector('#search');
  const container = document.querySelector('[data-posts-list]');

  if (!input || !container) return;

  const items = Array.from(container.querySelectorAll('[data-post-item]'));

  const filter = () => {
    const query = input.value.trim().toLowerCase();

    items.forEach((item) => {
      const text = item.textContent.toLowerCase();
      const matches = !query || text.includes(query);
      if (matches) {
        item.classList.remove('hidden');
      } else {
        item.classList.add('hidden');
      }
    });
  };

  input.addEventListener('input', filter);
}